function toggleShare() {
  if ($('.teacher__download').length > 0) {
    let button = $('.teacher__download');
    let timer;
    button.on('click', function() {
      let currentButton = $(this);
      let currentURL = window.location.href;

      // Copy URL to clipboard
      navigator.clipboard.writeText(currentURL).then(function() {
        console.log('URL copied to clipboard');
      }).catch(function(err) {
        console.error('Could not copy URL: ', err);
      });

      // Add active class to button and show tip
      currentButton.addClass('active');
      $('.teacher__download__tip').fadeIn();

      if (timer) {
        clearTimeout(timer);
      }
      timer = setTimeout(function() {
        currentButton.removeClass('active');
        $('.teacher__download__tip').fadeOut();
      }, 2000);
    });
  }
}
toggleShare();